"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var RowContext = react_1.createContext({
    isEditing: false,
});
exports.default = RowContext;
